import { Box } from '@mui/material'

import { CONTAINER_SPACING } from 'providers/material-ui/theme/constants'

export const GapBox = (): React.JSX.Element => <Box sx={{ mb: CONTAINER_SPACING }} />
